var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1430_35255",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1430_35255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99994 21.0001V8.00005L12.9999 2.05005C13.2499 1.80005 13.5456 1.65405 13.8869 1.61205C14.2289 1.57072 14.5583 1.63339 14.8749 1.80005C15.1916 1.96672 15.4249 2.20005 15.5749 2.50005C15.7249 2.80005 15.7583 3.10839 15.6749 3.42505L14.5499 8.00005H20.9999C21.5333 8.00005 21.9999 8.20005 22.3999 8.60005C22.7999 9.00005 22.9999 9.46672 22.9999 10.0001V12.0001C22.9999 12.1167 22.9833 12.2417 22.9499 12.3751C22.9166 12.5084 22.8833 12.6334 22.8499 12.7501L19.8499 19.8001C19.6999 20.1334 19.4499 20.4167 19.0999 20.6501C18.7499 20.8834 18.3833 21.0001 17.9999 21.0001H6.99994ZM8.99994 8.85005V19.0001H17.9999L20.9999 12.0001V10.0001H11.9999L13.3499 4.50005L8.99994 8.85005ZM3.99994 21.0001C3.44994 21.0001 2.97927 20.8044 2.58794 20.4131C2.19594 20.0211 1.99994 19.5501 1.99994 19.0001V10.0001C1.99994 9.45005 2.19594 8.97905 2.58794 8.58705C2.97927 8.19572 3.44994 8.00005 3.99994 8.00005H6.99994V10.0001H3.99994V19.0001H6.99994V21.0001H3.99994Z",
    fill: "currentcolor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeDefault);
export default __webpack_public_path__ + "static/media/likeDefault.aaa9f9e4385944f02e57dd8da75aa184.svg";
export { ForwardRef as ReactComponent };